module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "user-avatar-link",
    attrs: {
      "href": _vm.linkHref
    }
  }, [_c('user-avatar-image', {
    attrs: {
      "img-src": _vm.imgSrc,
      "img-alt": _vm.imgAlt,
      "css-classes": _vm.imgCssClasses,
      "size": _vm.imgSize,
      "tooltip-text": _vm.tooltipText,
      "tooltip-placement": _vm.tooltipPlacement
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcca3766"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bcca3766"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue
// module chunks = common_vue